import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';
import {
    ConfigTableInterface,
    ResponseResult,
} from 'src/app/shares/interfaces';
import {
    StatusCode,
    Action,
    Pagination,
    RatingResult,
} from 'src/app/shares/constants';
import {
    AuthService,
    ContractService,
} from 'src/app/shares/services';

@Component({
    selector: 'app-table-with-checkbox-v2',
    templateUrl: './table-with-checkbox-v2.component.html',
    styleUrls: ['./table-with-checkbox-v2.component.scss'],
})
export class TableWitCheckboxV2Component {
    configTable: ConfigTableInterface = {
        Data: [],
        ColWidth: [],
        ActionHeader: [],
        Action: [],
        Header: [
            {Key: 'batchCode', Name: 'Product.batchCode'},
            {Key: 'cartonNumber', Name: 'Product.cartonNumber'},
            {Key: 'fermenterName', Name: 'Product.fermenterName'},
            {Key: 'weight', Name: 'Product.weight'},
            {Key: 'ratingDate', Name: 'Product.ratingDate', Type: 'Date'},
            {Key: 'ratingResult', Name: 'Product.ratingResult'},
            {Key: 'price', Name: 'Product.price', Type: 'Currency'},
        ],
    };
    footer = false;
    totalPrice = null;
    deducedQuantity: any = null;
    cutBeanOnFarm: any = null;
    dataFilter: any = {};
    pageSize: number = Pagination.PageSize;
    pageIndex: number = Pagination.PageIndex;
    cateId: number = null;
    ratingId: string = null;
    ratingResult = RatingResult;
    dateFormat = 'dd/MM/yyyy';
    checkedDisable = false;
    actionType: any = Action;
    gradeType: any = [];
    listOfSelection = [
        {
            text: 'Chọn tất cả',
            onSelect: () => {
                this.checkAll(true);
            }
        },
        {
            text: 'Chọn số lẻ',
            onSelect: () => {
                this.configTable.Data.forEach((data, index) => (this.mapOfCheckedId[data.id] = index % 2 !== 0));
                this.refreshStatus();
            }
        },
        {
            text: 'Chọn số chẵn',
            onSelect: () => {
                this.configTable.Data.forEach((data, index) => (this.mapOfCheckedId[data.id] = index % 2 === 0));
                this.refreshStatus();
            }
        }
    ];
    isAllDisplayDataChecked = false;
    isIndeterminate = false;
    mapOfCheckedId: { [key: string]: boolean } = {};
    taxPrice = 0;
    @Output() actionClicked = new EventEmitter<any>();

    constructor(
        private authService: AuthService,
        private contractService: ContractService,
    ) {
    }

    dateChange($event) {
    }

    setData(contractId, fermenterId, actionType, priceTable, taxPrice?: number) {
        this.dataFilter.fermenterId = fermenterId;
        this.dataFilter.contractId = contractId;
        this.dataFilter.priceTable = priceTable;
        this.taxPrice = taxPrice;
        this.actionType = actionType;
        if (actionType === Action.Create) {
            this.mapOfCheckedId = {};
            this.checkedDisable = false;
            this.totalPrice = 0;
            this.configTable.Data = [];
            if (fermenterId !== null) {
                this.getProductList();
            }
        } else if (actionType === Action.Edit) {
            this.getContractDetail(contractId);
        }
    }

    changeCate($event) {
        this.getProductList();
    }

    getProductList() {
        const startDate = new Date();
        const endDate = this.dataFilter.date;
        this.configTable.Data = [];
        const filterModel = {
            categoryId: this.cateId,
            fermenterId: this.dataFilter.fermenterId,
            startDate,
            endDate,
            ratingResult: this.ratingId,
            filter: '',
            pageSize: 0,
            pageIndex: 0,
            provinceId: 0,
            districtId: 0,
            wardId: 0
        };
        this.contractService.getCrudeProduct(filterModel).subscribe((res: ResponseResult) => {
            if (res.statusCode === StatusCode.Status200OK) {
                this.footer = true;
                this.configTable.Data = res.data.items;
                this.configTable.Data.forEach((element, index) => {
                    const priceObj = this.dataFilter.priceTable.find((e) => e.key === element.ratingResult);
                    element.price = new Intl.NumberFormat().format(priceObj.price * element.weight);
                    element.priceRaw = priceObj.price * element.weight;
                    element.itemPrice = priceObj.price;
                });
                this.checkAll(true);
            }
        });
    }

    getContractDetail(contractId) {
        this.contractService.getDetail(contractId).subscribe((res: ResponseResult) => {
            if (res.statusCode === StatusCode.Status200OK) {
                this.configTable.Data = res.data.crudeProducts;
                let price = 0;

                this.configTable.Data.forEach((element, index) => {
                    price += element.price;
                    element.price = new Intl.NumberFormat().format(element.price);

                    if (element.ratingDate) {
                        const t = new Date(element.ratingDate);
                        element.ratingDate = t.getDate() + '/' + (t.getMonth() + 1) + '/' + t.getFullYear();
                    }
                });
                this.footer = true;
                this.checkAll(true, true);
                this.totalPrice = new Intl.NumberFormat().format(price + this.taxPrice);
                this.checkedDisable = true;
            }
        });
    }

    checkAll(value: boolean, callRefresh = true): void {
        this.configTable.Data.forEach(item => (this.mapOfCheckedId[item.id] = value));
        if (callRefresh) {
            this.refreshStatus();
        }
    }

    refreshStatus(): void {
        this.isAllDisplayDataChecked = this.configTable.Data.every(item => this.mapOfCheckedId[item.id]);
        this.isIndeterminate =
            this.configTable.Data.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
        let price = 0;
        // let currentProductRegisterRatingId = null;
        const productRegisterRatingIdUsed = [];
        this.cutBeanOnFarm = 0;
        this.deducedQuantity = 0;
        this.gradeType.AA = 0;
        this.gradeType.A = 0;
        this.gradeType.B = 0;
        // tslint:disable-next-line:forin
        for (const key in this.mapOfCheckedId) {
            const value = this.mapOfCheckedId[key];
            const materialObj = this.configTable.Data.find((e) => e.id + '' === key + '');
            materialObj.checked = value;
            if (value) {
                price += materialObj.priceRaw;
                if (materialObj.ratingResult === 'AA') {
                    this.gradeType.AA += materialObj.weight;
                }
                if (materialObj.ratingResult === 'A') {
                    this.gradeType.A += materialObj.weight;

                }
                if (materialObj.ratingResult === 'B') {
                    this.gradeType.B += materialObj.weight;
                }
                if (!productRegisterRatingIdUsed.includes(materialObj.productRegisterRatingId)) {
                    productRegisterRatingIdUsed.push(materialObj.productRegisterRatingId);
                    price += (materialObj.itemPrice * (materialObj.cutBeanOnFarm - materialObj.deducedQuantity));
                    this.cutBeanOnFarm += materialObj.cutBeanOnFarm;
                    this.deducedQuantity += materialObj.deducedQuantity;
                }
            }
            // if (currentProductRegisterRatingId !== materialObj.productRegisterRatingId) {
        }
        this.cutBeanOnFarm = parseFloat(this.cutBeanOnFarm + '').toFixed(2);
        this.deducedQuantity = parseFloat(this.deducedQuantity + '').toFixed(2);
        this.gradeType.AA = parseFloat(this.gradeType.AA + '').toFixed(2);
        this.gradeType.A = parseFloat(this.gradeType.A + '').toFixed(2);
        this.gradeType.B = parseFloat(this.gradeType.B + '').toFixed(2);
        this.totalPrice = new Intl.NumberFormat().format(price + this.taxPrice);
    }

}
